import { Reveal } from "./Reveal";

const scenes = [
  {
    image: "https://static.prod-images.emergentagent.com/jobs/34a06e80-8bfb-46bf-a2ac-7e5393b6be5e/images/066606324b5dc1d197277eafd8232bd69464f8961c820ca6557bb5db63d7d5af.jpeg",
    title: "Ruangan yang Bernapas",
    story: "Cahaya pagi, udara yang tenang, dan aroma yang perlahan mengisi ruangan. Sebelum sesi dimulai, biarkan ruangan Anda siap menyambut ketenangan.",
  },
  {
    image: "https://static.prod-images.emergentagent.com/jobs/34a06e80-8bfb-46bf-a2ac-7e5393b6be5e/images/c8dbd28cbefc021d192827a445ae1b56de411560ae4cbabeb3a8d8b497c162f4.jpeg",
    title: "Satu Semprotan, Satu Niat",
    story: "Semprotkan NALURA Essence ke udara. Butiran halusnya menangkap cahaya — dan seketika, pikiran tahu: ini waktunya melambat.",
  },
  {
    image: "https://static.prod-images.emergentagent.com/jobs/34a06e80-8bfb-46bf-a2ac-7e5393b6be5e/images/4211a987678c76ef28cf53c63d28bc36e732587439979791fb186518f3ea13bc.jpeg",
    title: "Masuki Alam Bawah Sadar",
    story: "Kenakan headphone, putar program NALURA, pejamkan mata. Saat aroma dan suara bekerja bersama, alam bawah sadar terbuka lebih cepat dan maksimal.",
  },
];

export const AromaGallery = () => (
  <section className="mt-24 md:mt-32" data-testid="aroma-gallery">
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">Galeri Aroma</p>
      <h2 className="font-display tracking-tighter text-3xl md:text-5xl max-w-3xl leading-tight mb-16">
        Suasana yang tercipta ketika ruangan dan aroma menyatu.
      </h2>
    </Reveal>
    <div className="grid md:grid-cols-3 gap-8 md:gap-10">
      {scenes.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.15} className={i === 1 ? "md:mt-12" : ""}>
          <figure data-testid={`aroma-scene-${i}`} className="group">
            <div className="overflow-hidden border border-[#211B10]/10 mb-6">
              <img
                src={s.image}
                alt={s.title}
                className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              />
            </div>
            <figcaption>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A67C1E] mb-2">0{i + 1}</p>
              <h3 className="font-display text-2xl tracking-tight mb-3">{s.title}</h3>
              <p className="text-sm text-[#211B10]/65 leading-relaxed">{s.story}</p>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
